module.exports = __webpack_public_path__ + "static/media/callIconWhite.b5cea3a1_UI.svg";